import { Stack } from '@zet/design-system'

const Spacer = ({ height = 16 }) => <Stack style={{ height }} />

export { Spacer }
